import { useQuery } from "@tanstack/react-query";

interface GameStatus {
    game_id: number
    state: number
    disabled: boolean
    is_vgep: boolean
    vgep_prefix: any
    min_gep_version: string
}


async function fetchOverwolfGameStatuses(): Promise<GameStatus[]> {
    return await (await window.fetch("https://game-events-status.overwolf.com/gamestatus_prod.json")).json();
}

function useGetOverwolfGameEventsDisabledQuery(gameId: string) {
    return {
        queryKey: [
            "overwolf-disabled-games",
        ],
        queryFn: () => fetchOverwolfGameStatuses(),
        /*
         * 5-min staleTime + 10-min poll + refetch-on-focus. The Overwolf status
         * feed drives the game-events "degraded" signal; a 1-hour cache meant a
         * user whose feed went yellow during an outage stayed yellow for up to an
         * hour after Overwolf recovered ("stuck yellow"). Short cache + refresh
         * lets recovery reach an already-open client. (Longer-term the feed state
         * should move server-side into the health snapshot — see BUILD notes.)
         */
        staleTime: 5 * 60000,
        refetchInterval: 10 * 60000,
        refetchOnWindowFocus: true,
        enabled: !!gameId,
    } as const;
}

export default function useGetOverwolfGameEventsDisabled(gameId: string) {
    const { data } = useQuery<GameStatus[]>(useGetOverwolfGameEventsDisabledQuery(gameId));
    const state = data?.find((game) => game.game_id === parseFloat(gameId))?.state ?? 1;

    /*
     * 1 is available
     * 0 is unsupported
     * 2 is may be unavailable
     * 3 is unavailable
     */
    const gameEventsDisabled = state !== 1;

    return { gameEventsDisabled,
        state };
}
